import { render, staticRenderFns } from "./ResumenCifras.vue?vue&type=template&id=1a08994b&"
import script from "./ResumenCifras.vue?vue&type=script&lang=js&"
export * from "./ResumenCifras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports